/*
redirect-api.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('redirectApi',['angular', 'messages'], function () {

    // Module Dependencies
    var dependencies = [
        'Services.Messages'
    ];

    // Module Definition
    var mod = angular.module('Services.RedirectApi', dependencies);

    /**
     * @name redirectApi
     * @type factory
     *
     * @description
     * A factory that provides methods for making requests to the redirect  REST API.
     */
    mod.factory('redirectApi', ['$q', '$log', '$http', '$window', function ($q, $log, $http, $window) {
        /**
         * Base url for requests to the login REST API.
         */
        var REDIRECT_URL = '/redirect';


        /**
         * Public API
         */
        function redirectToValidation(data) {
            var deferred = $q.defer(),
                settings = settings || {};

            var DATA_URL = REDIRECT_URL;

            // Send the request
            $.ajax({
                async: false,
                contentType: 'application/json',
                headers: {"Authorization": "Bearer " + sessionStorage.getItem('cIdToken')},
                data: JSON.stringify(data),
                type: 'post',
                url: DATA_URL,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(result) {
                $log.log('Success: loginApi: POST "' + DATA_URL + '"');
                localStorage.setItem('ideosanteinprogress', '1');
                $window.location.href = data.redirectUrl;
                deferred.resolve(result);
            }

            function error(jqXHR) {
                var errorMsg = JSON.parse(jqXHR.responseText).message;
                $log.error('Error: loginApi: ' + errorMsg);
                deferred.reject(errorMsg);
            }
        }

        function redirectToSSO(data) {
            $window.location.href = data.orgSSOIdentifier + '/SSO' + (data.requestor ? '?req=' + data.requestor : '');
        }


        return {
            // POST
            redirectToValidation: redirectToValidation,
            redirectToSSO: redirectToSSO
        };

    }]);

});

